module.exports = __webpack_public_path__ + "static/media/Group 11555 (1).00444aa4.svg";